import { useLookupStore } from "./lookupStore.ts";
import { useOnboardingStore } from "./onboardingStore.ts";
import { journeyStorage } from "../utilities/session-storage.ts";
import type { LookupInput } from "../utilities/signup-lookup.ts";

let hydration: Promise<void> | undefined;
export function hydrateJourney() {
	if (!hydration) {
		hydration = Promise.all([
			useLookupStore.persist.rehydrate(),
			useOnboardingStore.persist.rehydrate(),
		])
			.then(() => undefined)
			.catch(() => undefined)
			.finally(() => {
				// The old unscoped key cannot safely identify its site variant.
				journeyStorage.removeItem("solstice-onboarding-store");
				useLookupStore.setState({ hasHydrated: true });
				useOnboardingStore.setState({ hasHydrated: true });
			});
	}
	return hydration;
}

export function clearJourney() {
	useLookupStore.getState().clearLookup();
	useOnboardingStore.getState().clearOnboardingData();
}

export function submitLookup(input: LookupInput) {
	useOnboardingStore.getState().clearOnboardingData();
	useLookupStore.getState().submitLookup(input);
}
